import { render, staticRenderFns } from "./SurveyFillerTerms.vue?vue&type=template&id=48873c32"
import script from "./SurveyFillerTerms.vue?vue&type=script&lang=js"
export * from "./SurveyFillerTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports